import { Navigate, Route, Routes } from "react-router-dom";
import ScrollManager from "./components/common/ScrollManager";
import MainLayout from "./components/layout/MainLayout";
import ProtectedAdminRoute from "./routes/ProtectedAdminRoute";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import TestimonialsPage from "./pages/TestimonialsPage";
import AdminTestimonialsPage from "./pages/admin/AdminTestimonialsPage";
import AustraliaPage from "./pages/study/AustraliaPage";
import CanadaPage from "./pages/study/CanadaPage";
import CountryNotFoundPage from "./pages/study/CountryNotFoundPage";
import EuropePage from "./pages/study/EuropePage";
import GermanyPage from "./pages/study/GermanyPage";
import IrelandPage from "./pages/study/IrelandPage";
import NewZealandPage from "./pages/study/NewZealandPage";
import UkPage from "./pages/study/UkPage";
import UaePage from "./pages/study/UaePage";
import UsaPage from "./pages/study/UsaPage";

function App() {
  return (
    <>
      <ScrollManager />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route element={<ProtectedAdminRoute />}>
          <Route path="/admin" element={<Navigate replace to="/admin/testimonials" />} />
          <Route path="/admin/testimonials" element={<AdminTestimonialsPage />} />
        </Route>

        <Route element={<MainLayout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/testimonials" element={<TestimonialsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/study-in/usa" element={<UsaPage />} />
          <Route path="/study-in/canada" element={<CanadaPage />} />
          <Route path="/study-in/uk" element={<UkPage />} />
          <Route path="/study-in/australia" element={<AustraliaPage />} />
          <Route path="/study-in/uae" element={<UaePage />} />
          <Route path="/study-in/new-zealand" element={<NewZealandPage />} />
          <Route path="/study-in/europe" element={<EuropePage />} />
          <Route path="/study-in/ireland" element={<IrelandPage />} />
          <Route path="/study-in/germany" element={<GermanyPage />} />
          <Route path="/study-in/:countrySlug" element={<CountryNotFoundPage />} />
          <Route path="*" element={<Navigate replace to="/" />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
